/**
 * PDP `.full-height--desktop`: Firefox (and some layouts) ignore or mis-resolve
 * max-height: calc(100vh - var(--header-group-height)) when --header-group-height is wrong
 * or sticky flex sizing interacts badly. Set an explicit pixel cap from layout measurements.
 */
(function () {
  function viewportHeight() {
    return window.visualViewport?.height ?? window.innerHeight;
  }

  function apply() {
    const roots = document.querySelectorAll('.product-details.full-height--desktop');
    if (!roots.length) return;

    const headerGroup = document.querySelector('#header-group');
    const headerOffset = headerGroup instanceof HTMLElement ? headerGroup.offsetHeight : 0;
    const px = Math.max(0, Math.round(viewportHeight() - headerOffset));

    roots.forEach((el) => {
      el.style.setProperty('--full-height-details-max', `${px}px`);
    });
  }

  function init() {
    apply();
    requestAnimationFrame(apply);
    window.addEventListener('load', apply, { once: true });

    window.addEventListener('resize', apply);
    window.visualViewport?.addEventListener('resize', apply);

    const headerGroup = document.querySelector('#header-group');
    if (!headerGroup || typeof ResizeObserver === 'undefined') return;

    const ro = new ResizeObserver(() => apply());
    ro.observe(headerGroup);
    const headerComponent = headerGroup.querySelector('header-component');
    if (headerComponent instanceof HTMLElement) {
      ro.observe(headerComponent);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
